<app-auth-inner
  *ngIf="!allMessengersService.isAuth;
    else contentRef
  "></app-auth-inner>

<ng-template #contentRef>
  <div class="layout showEffect">
    <app-navbar *ngIf="!interfaceService.isLeadsDomain"></app-navbar>
    <app-leads-navbar [compact]="true" *ngIf="interfaceService.isLeadsDomain"></app-leads-navbar>
    <!-- Sidebar -->
    <div #sideBar class="sidebar leftSidebar">
      <ng-template [ngIf]="Service.type !== 'all' && !Service?.isAuth" [ngIfElse]="tabs">
        <app-sign-telegram *ngIf="fixTypePipe.transform(Service.type) === 'telegram'"></app-sign-telegram>
        <app-sign-skype *ngIf="Service.type === 'skype'"></app-sign-skype>
        <app-sign-vk *ngIf="Service.type === 'vk'"></app-sign-vk>
        <app-sign-whatsapp *ngIf="Service.type === 'whatsapp'"></app-sign-whatsapp>
        <app-sign-fellowdesk *ngIf="Service.type === 'fellowdesk'"></app-sign-fellowdesk>
      </ng-template>
      <ng-template #tabs>
        <tabset #staticTabs class="tab-icons d-block" type="pills">
          <tab>
            <ng-template tabHeading>
              <i-feather tooltip="Переписки и рассылка" placement="bottom" name="message-square" class="icon-lg"></i-feather>
            </ng-template>
            <div>
              <app-chat-list
                [Service]="Service"
                (onSettings)="selectTab(2)"
                *ngIf="allMessengersService?.Service?.isAuth || Service.type === 'all' || allMessengersService?.Service?.type === 'sender'"
                [type]="'all'"
              ></app-chat-list>
            </div>
          </tab>
          <!--<tab>
            <ng-template tabHeading>
              <i-feather tooltip="Написать" placement="bottom" name="edit" class="icon-lg"></i-feather>
            </ng-template>
            <app-chat-new
              (detectChange)="cd.detectChanges()"
              [Service]="Service"
              (onClose)="selectTab(0)"
            ></app-chat-new>
          </tab>-->
          <tab>
            <ng-template tabHeading>
              <i-feather
                *ngIf="Service.type !== 'all'"
                tooltip="Профиль"
                placement="bottom"
                name="user"
                class="icon-lg"
              ></i-feather>
              <i-feather
                *ngIf="Service.type === 'all'"
                tooltip="Настройки"
                placement="bottom"
                name="settings"
                class="icon-lg"
              ></i-feather>
            </ng-template>
            <app-profile [Service]="Service" class="h-100"></app-profile>
          </tab>
        </tabset>
      </ng-template>
    </div>
    <!-- tabs.html -->
    <!-- Sidebar -->
    <!-- Main Content -->
    <ng-template #player>
      <app-music-player></app-music-player>
    </ng-template>
    <div class="main w-100" [class.chat-media-open]="interfaceService.showTabsInput">
      <app-chat-show
        class="w-100"
        (onNewChat)="selectTab(1)"
        (onOpenProfile)="selectTab(2)"
        [Service]="fellowdeskService"
      >
        <ng-container *ngTemplateOutlet="player"></ng-container>
      </app-chat-show>
    </div>
    <!-- Main Content -->
  </div>
  <div class="rootPlayer" [class.hidden]="allService._openChatId || true">
    <ng-container *ngTemplateOutlet="player"></ng-container>
  </div>
</ng-template>
